import Link from "next/link";
import styles from "./blockTwo.module.scss";
import Image from "next/image";
import PromptInfo from "../promptInfo/promptInfo";

export default function BlockTwo({ data, load, isAuth, thisIsFile, handlerClick, isSoon, dictionary, thisIsApp, serviceData, queryParams }) {
	const afterImageData = data.After_image.data.attributes;
	const beforeImageData = data.Before_image.data.attributes;
	const accept = `.jpg, .jpeg, .heic, .heif, .png, image/png, image/jpeg`;

	console.log(data);

	return (
		<section className={styles.section}>
			{data?.video_url?.length > 0 && (
				<div className={styles.videoWrapper}>
					<iframe
						width="560"
						height="315"
						src={data?.video_url}
						title="YouTube video player"
						frameborder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
						referrerpolicy="strict-origin-when-cross-origin"
						allowfullscreen
					></iframe>
				</div>
			)}
			<div className={styles.sectionContent}>
				<div className={styles.before}>
					{beforeImageData && <Image src={beforeImageData.url} alt={beforeImageData.alternativeText} width={beforeImageData.width} height={beforeImageData.height} loading="lazy" unoptimized={true} />}
					{thisIsFile && <span>{dictionary["before"] || "Before"}</span>}
					{beforeImageData.caption?.includes("prompt: ") && (<PromptInfo prompt={beforeImageData.caption.replace("prompt: ", "")} />)}
				</div>
				<div className={styles.after}>
					{afterImageData && <Image src={afterImageData.url} alt={afterImageData.alternativeText} width={afterImageData.width} height={afterImageData.height} loading="lazy" unoptimized={true} />}
					{thisIsFile && <span>{dictionary["after"] || "After"}</span>}
					{afterImageData.caption?.includes("prompt: ") && (<PromptInfo prompt={afterImageData.caption.replace("prompt: ", "")} />)}
				</div>

				<div className={styles.text}>
					<h2 className={styles.title}>{data.Title}</h2>
					<h3 className={styles.subtitle}>{data.Subtitle}</h3>
					<p className={styles.description}>{data.Description}</p>

					{load && data.Button && isSoon && (
						<button className={styles.btn} onClick={handlerClick} disabled={isAuth}>
							{dictionary["Coming soon"] || "Coming soon"}
						</button>
					)}

					{load && data.Button && !isSoon && !thisIsApp && (
						<>
							{thisIsFile ? (
								<Link className={styles.btn} href={`/${serviceData.url_name}${queryParams !== "" ? `?${queryParams}` : ""}`}>
									{dictionary["Try"]}
								</Link>
							) : (
								<button className={styles.btn} onClick={handlerClick}>
									{dictionary["Create"] || "Create"}
								</button>
							)}
						</>
					)}
				</div>
			</div>
		</section>
	);
}
